import { useEffect } from 'react';
import { Redirect } from 'react-router-dom';

import ProjectsExplorer from '../../components/ProjectsExplorer';
import SectionHead from '../../components/SectionHead';
import { useAuth } from '../../hooks/auth';
import { useFilters } from '../../hooks/projectFilters';

import Container from './styles';

const Favorites = () => {
  const { isLoggedIn } = useAuth();
  const { resetFilters } = useFilters();

  // Os filtros são compartilhados com a vitrine principal: entrar nos favoritos
  // carregando a busca da tela anterior esconderia o que o usuário salvou.
  useEffect(() => {
    resetFilters();
    document.title = 'Favoritos | Portal Due It';
  }, []);

  if (isLoggedIn === null) return null;

  if (!isLoggedIn) return <Redirect to="/login" />;

  return (
    <Container>
      <SectionHead
        title="Meus favoritos"
        description="Os projetos que você salvou para criar depois."
      />
      <ProjectsExplorer
        onlyFavorites
        emptyText="Você ainda não favoritou nenhum projeto"
      />
    </Container>
  );
};

export default Favorites;
